import { withTheme } from "@mui/material";
import { red } from "@mui/material/colors";
import { defaultTheme } from "react-admin";

const appTheme = {
    ...defaultTheme,
    body:{
        margin: 0,
    },
    palette: {
        mode: 'light',
        primary: {
            main: "#BE0F34",
        },
        secondary: {
            main: "#AE223F",
        },
        error: {
            main: red.A400,
        },
        info: {
            main: '#ffffff'
        }
    },
    typography:{
        fontFamily: ['Helvetica', 'Arial', 'Segoe UI', 'Roboto'].join(','),
        body: {
            color: 'rgba(0, 0, 0, 0.6)',
            fontSize: '.8rem',
        },
        label: {
            color: 'rgba(0, 0, 0, 0.6)',
        fontSize: '1.8rem',
        },
        h6: {
            color: '#e32fe5'
        },
    },
};

appTheme.typography.body = {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    color: '#e32fe5',
    fontSize: '.8rem',
}
appTheme.typography.label = {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '1.8rem',
}
export default appTheme;
